<template>
    <div class="bind-banner" v-if="showing">
      <div v-if="bindRoleInfo"> <span>您好，</span> <span class="nickname-ellipsis" :style="`color: ${fontColor}`">{{bindRoleInfo.roleName}}</span><span :style="`color: ${fontColor}`" @click="_show_bind_modal">【修改绑定】</span></div>
      <div v-else>您好，请<span  :style="`color: ${fontColor}`" @click="_show_bind_modal">【绑定游戏账号】</span></div>

      <bind-account-modal ref="bindAccountModal" class="child"></bind-account-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import BindAccountModal from '@/components/liveLink/BindAccountModal'
import { getLiveLinkAccountInfo } from '@/service/apis'

export default {
  name: 'BindBanner',

  components: { BindAccountModal },
  props: ['login'],
  data () {
    return {
      fontColor: '#eee',
      bindingOccurred: false,
      showing: false
    }
  },
  created () {
    this.showing = true
    this._init_data()
    this._init_event()
  },
  mounted () {
    if (!this.h5ConfigDetails[0]['llkText']) {
      return
    }

    this.fontColor = this.h5ConfigDetails[0]['llkText']['llkTextColor'][0]
  },
  methods: {
    _show_bind_modal () {
      if (!this.isLogin) {
        this.login()
        return
      }

      this.$sensors.track('app_page_click', {button_name: 'log_on'})
      this.$refs.bindAccountModal.show()
    },
    async _init_data (isRefresh = false) {
      let res = await getLiveLinkAccountInfo(this.userInfo.userId)
      const miniProgram = {
        actId: this.h5ConfigDetails[0]['llkText']['activityId'][0],
        gameId: this.h5ConfigDetails[0]['llkText']['gameId'][0]
      }

      this.$store.commit('SET_BIND_ROLE_INFO', {
        roleInfo: res,
        isRefresh,
        miniProgram
      })
    },
    _init_event () {
      window.eventBus.$on('onBindLiveLink', async () => {
        this.bindingOccurred = true
      })

      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && this.bindingOccurred) {
          this._init_data(true)
          this.bindingOccurred = false
        }
      })
    }
  },
  filter: {

  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath', 'userInfo', 'isLogin', 'bindRoleInfo'])
  },
  watch: {

  }
}
</script>

<style scoped lang="less">
  .bind-banner {
    position: absolute;
    bottom: 5.4rem;
    left: 0;
    right: 0;
    width: 100vw;
    height: 3rem;
    line-height: 3rem;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
  }

  .bind-banner div {
    font-weight: 600;
    font-size: 1.1rem;
    color: #FFF;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .child {
    line-height: initial; /* 使用默认行高 */
  }
</style>
